export default __webpack_public_path__ + "static/media/6-1.35f727c5.webp";